import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  logout,
  GetUserProfile,
  DeleteAccount,
} from "../../utils/api.services";
import {
  logoutRedirection,
  TOAST_SUCCESS,
  SWIT_LOGOUT,
  SWIT_DELETE,
  TOAST_ERROR,
} from "../../config/common";

import Offcanvas from "react-bootstrap/Offcanvas";

const WithLoginHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [userdata, setUserdata] = useState("");

  const [show, setShow] = useState(false);

  useEffect(() => {
    GetUserProfile().then((response) => {

      if (response?.code === 200) {
        setUserdata(response?.data);
        if (response?.data?.profile_picture) {
          setImagePreview(response?.data.profile_picture);
        }
      } else {
        // TOAST_ERROR(response.message);
        navigate('/Home')
      }
    });
  }, []);

  const handleLogout = async () => {
    SWIT_LOGOUT().then((result) => {
      if (result.isConfirmed) {
        logout().then((response) => {
          if (response?.code === 200) {
            TOAST_SUCCESS(response?.message);
            logoutRedirection();
            navigate("/login");
          } else {

            TOAST_ERROR(response?.message);
          }
        });
      }
    });
  };

  const handleDelete = async () => {
    SWIT_DELETE().then((result) => {
      if (result.isConfirmed) {
        DeleteAccount().then((response) => {
          if (response?.code === 200) {
            TOAST_SUCCESS(response?.message);
            logoutRedirection();
            navigate("/login");
          } else {
            TOAST_ERROR(response?.message);
          }
        });
      }
    });
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="navbar">
                <Link className="navbar-brand" to="/Home">
                  <img
                    src="assets/images/logo/logo-icon.svg"
                    alt="logo"
                    className="comapany-logo img-contain"
                  />
                </Link>
                <ul className="navbar-nav-wl">
                  <li className="nav-item">
                    <Link to="/Home" className="nav-link">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/about-us" className="nav-link">
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/contact-us" className="nav-link">
                      Contact Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/withlogin-subscription" className="nav-link">
                      Subscription
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link to="/withlogin-our-services" className="nav-link">
                      Our Services
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/my-estimator" className="nav-link">
                      My Estimator
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/our-services-home-owner" className="nav-link">
                      Home Owner Service
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/my-estimator-home-owner" className="nav-link">
                      Home Owner My Estimator
                    </Link>
                  </li> */}
                  {userdata && userdata.user_type === 'contractor' ? (
                    <>
                      <li className="nav-item">
                        <Link to="/withlogin-our-services" className="nav-link">
                          Our Services{" "}
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/my-estimator" className="nav-link">
                          {" "}
                          My Estimator{" "}
                        </Link>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="nav-item">
                        <Link to="/home_owner_our-services" className="nav-link">
                          Home Owner Service
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/home_owner_estimate" className="nav-link">
                          {" "}
                          Home Owner My Estimator{" "}
                        </Link>
                      </li>
                    </>
                  )}
                  <li className="nav-item" style={{ position: "relative" }}>
                    <Link
                      to="/user-notification"
                      className="nav-link"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                        borderRadius: "25px",
                        color: "#fff",
                        textDecoration: "none",
                        transition: "background-color 0.3s",
                        position: "relative",
                      }}
                    >
                      <i className="fas fa-bell" style={{ fontSize: "24px", color: "#fff" }}></i>
                      {userdata.unread_notification > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "1px",
                            backgroundColor: "#ff4141",
                            color: "#fff",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            minWidth: "20px",
                            textAlign: "center",
                            zIndex: 1,
                          }}
                        >
                          {userdata.unread_notification}
                        </span>
                      )}
                    </Link>
                  </li>


                  <li className="nav-item">
                    <div className="AvatarDropdown">
                      <div className="dropdown">
                        <button
                          className="avatarDropdown"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="web-avatar">
                            <img
                              src={imagePreview}

                              className="profile-img img-cover"
                            />
                          </div>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="/edit-profile">
                              <img
                                src="assets/images/icons/profile.svg"

                                className="AvatarDropIcon"
                              />
                              Profile
                            </Link>
                          </li>
                          <li>
                            {userdata.login_type === 'S' && (
                              <Link className="dropdown-item" to="/change-password">
                                <img
                                  src="assets/images/icons/change-password-icon.svg"
                                  alt="Change Password"
                                  className="AvatarDropIcon"
                                />
                                Change Password
                              </Link>
                            )}
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleDelete}
                            >
                              <img
                                src="assets/images/icons/delete.svg"
                                alt="Delete Account"
                                className="AvatarDropIcon"
                              />
                              Delete Account
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleLogout}
                            >
                              <img
                                src="assets/images/icons/logout.svg"
                                alt="Log Out"
                                className="AvatarDropIcon"
                              />
                              Log Out
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>

                <ul className="UserWlUl">
                  <li className="nav-item" style={{ position: "relative" }}>
                    <Link
                      to="/user-notification"
                      className="nav-link"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 12px",
                        borderRadius: "25px",
                        color: "#fff",
                        textDecoration: "none",
                        transition: "background-color 0.3s",
                        position: "relative",
                      }}
                    >
                      <i className="fas fa-bell" style={{ fontSize: "24px", color: "#fff" }}></i>
                      {userdata.unread_notification >  0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "1px",
                            backgroundColor: "#ff4141",
                            color: "#fff",
                            borderRadius: "50%",
                            padding: "2px 6px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            minWidth: "20px",
                            textAlign: "center",
                            zIndex: 1,
                          }}
                        >
                          {userdata.unread_notification}
                        </span>
                      )}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <div className="AvatarDropdown">
                      <div className="dropdown">
                        <button
                          className="avatarDropdown"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="web-avatar">
                            <img
                              src={imagePreview}

                              className="profile-img img-cover"
                            />
                          </div>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="/edit-profile">
                              <img
                                src="assets/images/icons/profile.svg"

                                className="AvatarDropIcon"
                              />
                              Profile
                            </Link>
                          </li>
                          <li>
                            {userdata.login_type === 'S' && (
                              <Link className="dropdown-item" to="/change-password">
                                <img
                                  src="assets/images/icons/change-password-icon.svg"
                                  alt="Change Password"
                                  className="AvatarDropIcon"
                                />
                                Change Password
                              </Link>
                            )}
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleDelete}
                            >
                              <img
                                src="assets/images/icons/delete.svg"
                                alt="Delete Account"
                                className="AvatarDropIcon"
                              />
                              Delete Account
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={handleLogout}
                            >
                              <img
                                src="assets/images/icons/logout.svg"
                                alt="Log Out"
                                className="AvatarDropIcon"
                              />
                              Log Out
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item">
                    <button
                      className="headerWlToggleBtn"
                      type="button"
                      onClick={handleShow}
                    >
                      <img
                        src="assets/images/icons/ToggleIcon.svg"
                        alt="Toggle"
                        className="comapany-logo img-contain"
                      />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <Offcanvas show={show} onHide={handleClose} className="headerWithOutLoginOffcanvas" >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img
              src="assets/images/logo/logo-icon.svg"
              alt="Menu Icon"
              style={{ width: "50px", height: "50px", marginRight: "0px" }}
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navbar-nav">
            <li className="nav-item custom-style-1">
              <Link to="/Home" className="nav-link">
                Home
              </Link>
            </li>
            <li className="nav-item custom-style-2">
              <Link to="/about-us" className="nav-link">
                About Us
              </Link>
            </li>
            <li className="nav-item custom-style-3">
              <Link to="/contact-us" className="nav-link">
                Contact Us
              </Link>
            </li>
            <li className="nav-item custom-style-4">
              <Link to="/withlogin-subscription" className="nav-link">
                Subscription
              </Link>
            </li>
            {userdata && userdata.user_type === "contractor" ? (
              <>
                <li className="nav-item custom-style-5">
                  <Link to="/withlogin-our-services" className="nav-link">
                    Our Services
                  </Link>
                </li>
                <li className="nav-item custom-style-6">
                  <Link to="/my-estimator" className="nav-link">
                    My Estimator
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link to="/home_owner_our-services" className="nav-link">
                    Home Owner Service
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/home_owner_estimate" className="nav-link">
                    Home Owner My Estimator
                  </Link>
                </li>
              </>
            )}
            <li className="nav-item">
              <Link to="/user-notification" className="nav-link">
                Notifications
              </Link>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default WithLoginHeader;
